export default "__VITE_ASSET__6bdbcacc__"